<div class="modulo horario-culto-modulo default" *ngIf="template == null">
    <div class="modulo-content">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="bloco wow fadeIn" data-wow-delay="0.2s">
                        <h3>{{data.params.presencial_titulo}}</h3>
                        <div class="linha"></div>
                        <h4>{{data.params.presencial_descricao}}</h4> 
                        <div class="horarios">
                            <h5>{{data.params.presencial_subtitulo}}</h5>
                            <p>{{data.params.presencial_horarios}}</p>
                        </div> 
                        <div class="link" *ngIf="data.params.presencial_ativar_link">
                            <a [href]="data.params.presencial_link" target="_blank" title="Se inscreva aqui">
                                Faça sua inscrição aqui
                            </a>
                        </div>     
                    </div>    
                </div>   
                <div class="col-md-6">
                    <div class="bloco wow fadeIn" data-wow-delay="0.2s">
                        <h3>{{data.params.online_titulo}}</h3>
                        <div class="linha"></div>
                        <h4>
                            <a href="https://www.instagram.com/igrejagreenhousetc" target="_blank">
                                {{data.params.online_descricao}}
                            </a>
                        </h4> 
                        <div class="horarios">
                            <h5>{{data.params.online_subtitulo}}</h5>
                            <p>{{data.params.online_horarios}}</p>
                        </div>    
                    </div>  
                </div>    
            </div>  
        </div>  
    </div>    
</div> 
<div class="modulo horario-culto-modulo two" *ngIf="template == 'two'">
    <div class="modulo-title">
        <h3>Nossos Cultos</h3>
    </div>   
    <div class="modulo-content">
        <div class="row">
            <div class="col-md-5">
                <div class="item">
                    <h4>{{data.params.presencial_titulo}}</h4>
                    <p class="info">{{data.params.presencial_descricao}}</p>
                    <h5>{{data.params.presencial_subtitulo}}</h5>
                    <p>{{data.params.presencial_horarios}}</p>
                </div>    
            </div>
            <div class="col-md-7">
                <div class="item">
                    <h4>{{data.params.online_titulo}}</h4>
                    <p class="info">
                        <a href="https://www.instagram.com/igrejagreenhousetc" target="_blank">
                            {{data.params.online_descricao}}
                        </a>
                    </p>
                    <h5>{{data.params.online_subtitulo}}</h5>
                    <p>{{data.params.online_horarios}}</p>
                </div>    
            </div>
        </div>
    </div>    
</div>    